import type { Dict } from './index';

// Japonca sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const ja: Dict = {
  signInMethods: {
    googleLinked: "Googleアカウントが連携されています。",
    googleCodeSent: "登録済みの電話番号（末尾 {phone}）にコードを送信しました。",
    googleChooseHint: "選択したGoogleアカウントは、このnosubjectアカウントへのログイン用に連携されます。",
    googleStatusUnknown: "Googleの連携状態を確認できませんでした。もう一度確認してください。",
    googleLinkIntro: "Googleを連携する前に、このアカウントに登録された電話番号を確認してください。",
    googleLinkFailed: "処理を完了できませんでした。もう一度お試しください。",
    googleSendCode: "確認コードを送信",
    googleCodeLabel: "確認コード",
    googleStartAgain: "最初からやり直す",
    googleContinue: "Google で続行",
    googleFailed: "Google でのログインを完了できませんでした。もう一度お試しください。",
    googleNotLinked: "この Google アカウントは、まだ nosubject アカウントに連携されていません。",
    googleUnavailable: "Google でのログインはまだ利用できません。",
    title: "ログイン方法",
    intro: "このセクションは準備中です。ログイン方法を管理する機能は後日追加されます。",
    identity: "本人確認",
    identityInfo: "本人確認は、アカウントへのログインとは別の手続きです。",
  },
  safety: {
    title: '安全番号',
    compare: 'この番号を{name}と照合してください。一致していれば、第三者が間に入ってメッセージを読むことはできません。',
    explainInfo: 'この番号は、お二人の現在のすべての端末の暗号化キーから計算され、両方のスマートフォンで同じものが表示されます。どちらかが新しいスマートフォンやWebなどの端末を追加すると番号が変わるので、もう一度照合してください。確認済みの記録はこの端末にのみ保存されます。',
    qrLabel: '安全番号のQRコード',
    verified: '確認済み',
    notVerified: '未確認',
    markVerified: '確認済みにする',
    clearVerified: '確認を解除',
    peerUnavailable: 'この相手との暗号化はまだ有効ではありません。',
    selfUnavailable: 'この端末の暗号化キーはまだ準備できていません。',
    loadFailed: '安全番号を読み込めませんでした。',
  },
  backup: {
    title: 'チャットのバックアップ',
    explainInfo: '履歴はこの端末にあります。バックアップは復元コードで暗号化してサーバーに保管します。こちらでは開けません。',
    create: 'バックアップを作成',
    refresh: 'バックアップを更新',
    codeTitle: '復元コード',
    codeWarning: 'このコードを安全な場所に保存してください。失うと履歴は戻らず、こちらでも開けません。',
    restoreTitle: '履歴を復元',
    restorePlaceholder: '復元コード',
    restore: '復元',
    restored: '{count} 件のメッセージを復元しました。',
    restoreFailed: '履歴を開けませんでした。コードを確認してください。',
    failed: 'バックアップできませんでした。',
  },
  common: {
    infoHide: '説明を隠す: {subject}',
    infoShow: '説明を表示: {subject}',
    continue: '続ける',
    cancel: 'キャンセル',
    close: '閉じる',
    save: '保存',
    done: '完了',
    retry: '再試行',
    error: 'エラー',
    back: '戻る',
    search: '検索…',
    loading: '読み込み中',
    remove: '削除',
    offline: 'サーバーに接続できません。接続を確認してください。',
    sessionExpired: 'セッションが終了しました。再度サインインしてください。',
    tooManyRequests: 'リクエストが多すぎます。少し待ってからお試しください。',
  },
  time: {
    now: 'たった今',
    minAgo: '{n}分前',
    hourAgo: '{n}時間前',
    yesterday: '昨日',
    dayAgo: '{n}日前',
    weekAgo: '{n}週間前',
    weekAgoOne: '{n}週間前',
    today: '今日',
    dayYesterday: '昨日',
  },
  phone: {
    sendFailed: "コードを送信できませんでした。もう一度お試しください。",
    subtitle: '電話番号を入力してください',
    selectCountry: '国 / 地域',
    countrySearch: '国を検索…',
    architectureLink: '技術アーキテクチャとロードマップ ↗',

  },
  otp: {
    verifyFailed: "コードを確認できませんでした。もう一度お試しください。",
    invalidCode: "コードが無効か、有効期限が切れています。",
    rateLimited: "試行回数が多すぎます。しばらくしてからもう一度お試しください。",
    title: 'コードを入力',
    sentTo: '{phone}宛にSMSを送信しました',
    verify: '確認',
    resend: '再送信',

    tooManyAttempts: '試行回数が多すぎます。少し待ってからお試しください。',

    resendSent: '新しいコードを送信しました。',
    resendFailed: 'コードを送信できませんでした。接続を確認してもう一度お試しください。',
    resendWait: '{n} 秒後にもう一度リクエストできます',
  },
  university: {
    title: '大学は？',
    subtitle: '大学名を検索',
    placeholder: 'ハーバード、オックスフォード…',
    skip: 'スキップ',
  },
  profession: {
    title: 'お仕事は？',
    subtitle: '職業を検索してください',
    placeholder: '教師、開発者、看護師…',
    skip: 'スキップ',
  },
  isco: {
    '0': '軍隊',
    '1': '管理的職業従事者',
    '2': '専門的職業従事者',
    '3': '技術者、准専門職',
    '4': '事務従事者',
    '5': 'サービス職業、販売従事者',
    '6': '農林漁業従事者',
    '7': '技能工、関連職業従事者',
    '8': '設備・機械操作従事者',
    '9': '単純作業従事者',
  },
  isced: {
    '5': '準学士',
    '6': '学士',
    '7': '修士',
    '8': '博士',
  },
  profileCreate: {
    photoPickerFailed: "写真ライブラリを開けませんでした。",
    title: 'プロフィールを作成',
    addPhoto: '写真を追加',
    name: '名前',
    surname: '苗字',
  },
  terms: {
    title: '始める前に',
    age: '18歳以上です',
    accept: '利用規約とプライバシーポリシーを読み、同意します',
    termsLink: '利用規約',
    privacyLink: 'プライバシーポリシー',
    continue: '同意して続ける',
    saveFailed: '同意を保存できませんでした。接続を確認してもう一度お試しください。',
    docPlaceholder: 'この文書は近日公開予定です。',
  },
  locationConsent: {
    title: '位置情報は許可した場合のみ使用します',
    body: '写真撮影時に地区名と都市名を提案するため、位置情報へのアクセスが必要です。',
    privacy: 'この画面では位置情報を取得しません。撮影が完了した後にのみ使用し、正確な座標は保存しません。許可は後から端末の設定で変更できます。',
    allow: '位置情報を許可',
    later: '今はしない',
  },
  discover: {
    title: "見つける",
    categories: "職業カテゴリー",
    categoryHint: "プロフィールに掲載された職業から人を探せます。",
    all: "すべて",
    reset: "絞り込みを解除",
    failed: '読み込めませんでした',
    free: '無料',
    empty: 'まだ誰もいません',
  },
  userProfile: {
    smsVerifiedOn: "SMSで電話を確認済み · {date}",
    googleLinkedOn: "Googleアカウント連携済み · {date}",
    contactProofNote: "電話またはGoogleアカウントへのアクセスを確認したもので、本人確認ではありません。",
    failed: 'プロフィールを読み込めませんでした',
    sendMessage: 'メッセージを送る',
    buyTime: '対面予定を提案',
    block: 'ブロック',
    blockedNotice: '{name} をブロックしています。メッセージ・通話・面会は無効です。',
    blockTitle: '{name}をブロックしますか？',
    blockMessage: 'この人は今後、メッセージを送信できず、「見つける」タブでもあなたを見つけられなくなります。',
    blockConfirm: 'ブロック',
  },
  callHistory: {
    empty: 'まだ通話はありません',
    tabAll: 'すべて',
    tabMissed: '不在着信',
    emptyMissed: '不在着信はありません',
    failed: '通話履歴を読み込めませんでした',
    outgoing: '発信',
    incoming: '着信',
    missed: '不在着信',
    declined: '拒否',
    cancelled: 'キャンセル',
  },
  call: {
    title: '音声通話',
    calling: '発信中…',
    incoming: '着信',
    connecting: '接続中…',
    connected: '接続しました',
    reconnecting: '再接続中…',
    logAnswered: '音声通話',
    logAnsweredVideo: 'ビデオ通話',
    logNoAnswer: '応答なし',
    logMissed: '不在着信',
    logDeclined: '通話を拒否されました',
    logYouDeclined: '通話を拒否しました',
    logCancelled: '通話をキャンセルしました',
    ended: '通話終了',
    accept: '応答',
    decline: '拒否',
    hangUp: '終了',
    close: '閉じる',
    mute: 'マイクをミュート',
    unmute: 'マイクのミュートを解除',
    cameraOff: 'カメラをオフ',
    cameraOn: 'カメラをオン',
    flipCamera: 'カメラを切り替え',
    audioOutput: '音声出力：{route}',
    audioOutputTitle: '音声出力を選択',
    earpiece: '受話口',
    speaker: 'スピーカー',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'Bluetooth の許可がオフです。設定でオンにしてください。',
    wiredHeadset: '有線ヘッドセット',
    audioRouteFailed: '音声出力を変更できませんでした',
    acceptFailed: '通話に応答できませんでした。もう一度お試しください。',
    declineFailed: '着信を拒否できませんでした。もう一度お試しください。',
    endFailed: '通話を終了できませんでした。もう一度お試しください。',
    mediaConnectionFailed: '音声接続を確立できませんでした。通話は終了し、料金は発生していません。',
    remaining: '残り {time}',
    endingSoon: 'この通話はまもなく終了します。',
    spent: '{amount} 使用',
    earned: '{amount} 獲得',
    noAudioNotice: 'このバージョンではまだ音声は送信されません。通話フローと課金処理をテスト中です。',
    failed: '通話を開始できませんでした',
    insufficient: 'この通話には残高が足りません',
    busy: '相手は通話中です',
    notAllowed: '通話するには、どちらか一方がメッセージを送信している必要があります',
    notAccepting: 'この人は現在、通話を受け付けていません',
    priceFree: '無料',
    priceChanged: '通話料金が変わりました。新しい料金を確認して、もう一度お試しください。',
    rateLimited: '発信回数が多すぎます。少し待ってからもう一度お試しください。',
    reservationLinkUnavailable: 'この予約を通話に関連付けることはできません。代わりに通常の通話を開始できます。',
    missed: '不在着信',
    callNow: '今すぐ通話',
    videoNow: '今すぐビデオ通話',
    scheduledStartTitle: '予約通話',
    scheduledStartBody: '{name}さんとの予約通話の時間です。今すぐ発信しますか？',
    schedule: '通話を予約',
    scheduleTitle: '{name}さんとの通話を予約',
    subjectPlaceholder: '件名（任意）',
    priceNote: '通話料金：{price}',
    sendReservation: '予約リクエストを送信',
    reservationSent: 'リクエストを送信しました',
    reservationSentBody: '{name}さんに通話予約リクエストを送信しました。',
    reservationFailed: '通話予約リクエストを送信できませんでした',
    reservationBubble: '☎️ 通話予約をリクエストしました',
    reservationBubbleShort: '☎️ 通話予約',
    reservationLabel: '音声通話予約',
    rescheduleBubble: '☎️ 新しい通話時間が提案されました',
    rescheduleBubbleShort: '☎️ 新しい通話時間',
  },
  wallet: {
    title: 'ウォレット',
    failed: 'ウォレットを読み込めませんでした',
    availableBalance: '利用可能残高',
    earningsTitle: '自分の収益',
    earningsTotal: '獲得総額',
    earningsWithdrawable: '出金可能額',
    earningsEscrow: 'エスクロー中',
    addFunds: '入金する',
    addFundsDemo: 'デモ：アカウントにテスト残高を追加',
    addFundsFailed: '入金できませんでした。',
    topupLabel: '入金完了',
    transactions: '取引履歴',
    noTransactions: 'まだ取引がありません',
    waiting: '保留中',
    incomingRequest: '受信リクエスト',
    replied: '返信済み',
    earned: '獲得',
    refunded: '返金済み',
    requestPayout: '出金',
    payoutHint: '最大{amount}まで出金できます。',
    payoutAll: '全額を選択',
    payoutRequested: 'リクエストを受け付けました',
    payoutRequestedBody: '{amount}の出金リクエストを作成しました。まもなく処理されます。',
    payoutFailed: '出金リクエストを作成できませんでした',
    payoutRequests: '出金リクエスト',
    noPayouts: 'まだ出金リクエストはありません',
    payoutStatusPending: '保留中',
    payoutStatusPaid: '支払い済み',
    payoutStatusRejected: '却下',
    paymentAccount: '支払いアカウント',
    stripeConnect: '支払いアカウントを連携',
    stripeConnectInfo: '収益を受け取るために銀行口座を連携してください（Stripe、テストモード）',
    stripeConnected: '連携済み',
    stripeConnectFailed: '連携できませんでした',
  },
  calendar: {
    dateInputLabel: "日付",
    timeInputLabel: "時刻",
    dateInputHint: "年・月・日をYYYY-MM-DD形式で入力してください。",
    timeInputHint: "時刻を24時間表記のHH:MM形式で入力してください。",

    previousWeek: '前の週',
    nextWeek: '次の週',
    empty: '表示するリクエストはありません',
    failed: 'カレンダーを読み込めませんでした',
    statusPending: '返信待ち',
    statusAccepted: '承諾済み',
    statusDeclined: '辞退済み',
    statusCancelled: 'キャンセル済み',
    statusExpired: '期限切れ',
    accept: '承諾',
    decline: '辞退',
    cancel: 'キャンセル',
    cancelConfirmationTitle: 'この予約をキャンセルしますか？',
    cancelConfirmationAcceptedBody: '{name}さんとの確定済み予約をキャンセルします。相手に通知され、この操作は取り消せません。',
    cancelConfirmationPendingBody: '{name}さんに送った提案を取り下げます。相手に通知され、この操作は取り消せません。',
    actionFailed: '操作に失敗しました',
    proposeTitle: '{name}さんに対面予定を提案',
    locationPlaceholder: '場所（任意）',
    sendProposal: '提案を送る',
    proposalSent: '提案を送信しました',
    proposalSentBody: '{name}さんに対面予定を提案しました。',
    priceChangedBody: 'この予約の1分あたりの料金は{amount}になりました。提案は作成されていません。新しい料金を確認して、もう一度提案してください。',
    proposalFailed: '提案を送信できませんでした',
    meetupBubble: '📅 対面予定を提案しました',
    meetupBubbleShort: '📅 対面予定の提案',
    proposeAction: '📅 対面予定を提案',
    priceNote: '対面予定の料金：{price}',
    totalCost: '合計：{amount}',
    minutesShort: '分',
    tabRequests: 'リクエスト',
    tabCalendar: 'カレンダー',
    tabActive: '現在',
    tabHistory: '履歴',
    loadMore: 'さらに表示',
    noEventsForDay: 'この日の予定はありません',
    meetupLabel: '対面予定',
    reservationDetails: '予約の詳細',
    reservationParticipant: '相手',
    reservationHeld: '通話は行われました',
    reservationNotHeld: '通話は行われませんでした',
    reservationDateTime: '日時',
    reservationDuration: '所要時間',
    reservationRate: '1分あたり',
    reservationLocation: '場所',
    reservationSubject: '件名',
    reservationQuotedTotal: '見積合計',
    reservationBilledDuration: '課金時間',
    reservationSpentAmount: '支払額',
    reservationEarnedAmount: '獲得額',
    reservationSettledAt: '精算日時',
    reservationCreated: '作成日時',
    reservationResponded: '回答日時',
    reservationAcceptedAt: '承諾日時',
    reservationDeclinedAt: '辞退日時',
    reservationCancelledAt: 'キャンセル日時',
    reservationCancelledBy: 'キャンセルした人',
    reservationYou: '自分',
    reservationCancellationNotification: '通知の送信',
    reservationNotificationPending: '準備中',
    reservationNotificationProviderAccepted: '配信事業者が受け付けました',
    reservationNotificationSuppressed: '通知設定により送信されませんでした',
    reservationNotificationUnavailable: '送信可能な端末が見つかりませんでした',
    reservationPendingReschedule: '新しい提案日時',
    reservationNewTime: '新しい日付と時刻',
    proposeNewTime: '新しい時間を提案',
    rescheduleFuture: '新しい日時は現在より後で、予約済みの開始日時と1分以上異なる必要があります。',
    reservationCallTooEarly: 'この予約通話は開始15分前から利用できます。',
    reservationCallExpired: 'この予約の通話可能時間は終了しました。',
    reservationCallInProgress: 'この予約に関連付けられた通話はすでに開始されています。',
    reservationExecutionLocked: 'この予約通話は開始済みまたは終了済みのため、変更できません。',
    openReservation: '{name}さんとの予約詳細を開く',
    systemEventMeetupTitle: '{name}さんとの対面予定',
    systemEventCallTitle: '{name}さんとの予約通話',
    systemEventNotes: 'nosubjectで承諾されました。',
    systemCalendarCopyRemoved: 'システムカレンダーのコピーが削除されました',
    restoreSystemCalendarCopy: '復元',
    systemCalendarRestoreFailed: 'カレンダーのコピーを復元できませんでした。カレンダー接続とシステム権限を確認してください。',
    systemCalendarCopyChanged: 'システムカレンダーの時刻が変更されました',
    reviewSystemCalendarChange: '確認',
    systemCalendarChangeTitle: 'カレンダーの時刻が変更されました',
    systemCalendarChangeBody: 'この変更は相手には適用されていません。\n\nnosubject: {nosubject}\nシステムカレンダー: {system}',
    restoreNosubjectTime: 'nosubjectの時刻に戻す',
    systemCalendarTimeRestoreFailed: 'カレンダーコピーの時刻を修正できませんでした。接続とシステム権限を確認してください。',
    proposeReschedule: '相手に提案する',
    rescheduleSent: '新しい時間を提案しました',
    rescheduleSentBody: '新しい日時を{name}さんに提案しました。相手が承諾するまでは予約済みの日時が維持されます。',
    rescheduleFailed: '新しい時間を提案できませんでした。',
    rescheduleActionFailed: '時間の提案を更新できませんでした。',
    reschedulePendingReceived: '新しい時間の提案：{time}',
    reschedulePendingSent: '返答待ちの新しい時間：{time}',
    withdrawReschedule: '提案を取り下げる',
    rescheduleBubble: '📅 対面予定の新しい日時を提案しました',
    rescheduleBubbleShort: '📅 対面予定の新しい日時',
    connectionsTitle: 'カレンダー接続',
    connectionsInfo: '表示するカレンダーを選択',
    deviceCalendar: '端末のカレンダー',
    connect: '接続',
    openSettings: '設定を開く',
    permissionGranted: 'アクセス許可済み',
    permissionDenied: 'アクセスはオフです',
    permissionUnavailable: 'このビルドでは利用できません',
    permissionNotRequested: 'まだ接続されていません',
    devicePermissionInfo: '許可はこのボタンを押した後にのみ求められます。nosubject は選択したカレンダーと必要な期間だけを読み取り、この画面から予定を書き込みません。',
    selectCalendars: '表示するカレンダー',
    noDeviceCalendars: 'この端末に利用可能なイベントカレンダーがありません。',
    manageSystemPermission: 'システムのカレンダー許可を管理',
    connectionPrivacyInfo: '選択内容はこの端末のこのアカウント用に保存されます。外部予定の詳細は自分の表示だけに使われ、自動共有されません。',
    newBuildRequired: 'カレンダー接続には新しいアプリビルドが必要です。',
    connectionFailed: 'カレンダーを接続できませんでした。',
    disconnect: '接続を解除',
    disconnectTitle: 'カレンダーの接続を解除しますか？',
    disconnectBody: 'nosubject はこの端末でカレンダーの読み取りと、新たに承諾された予定の書き込みを停止します。選択内容とローカルの対応付けは削除されますが、システムカレンダーの既存の予定は残ります。システム権限は端末設定で別途取り消せます。',
    disconnectFailed: 'カレンダーの接続を解除できませんでした。',
    selectionSaveFailed: 'カレンダーの選択を保存できませんでした。',
    allDay: '終日',
    recurring: '繰り返し',
    availabilityFree: '空き時間',
    availabilityBusy: '予定あり',
    availabilityTentative: '仮',
    availabilityUnavailable: '利用不可',
    untitledExternalEvent: 'タイトルなしの予定',
    externalEventsFailed: '外部カレンダーの予定を読み込めませんでした。',
    hideExternalEvent: 'この表示から「{title}」を非表示にする',
    hideExternalEventFailed: '予定を非表示にできませんでした。',
    restoreHiddenExternalEvents: '非表示の予定をもう一度表示',
    restoreHiddenExternalEventsFailed: '非表示の予定を再表示できませんでした。',
    hiddenExternalEventCount: 'この端末で{count}件の予定を非表示中',
    checkIncompleteTitle: 'カレンダーの確認が完了しませんでした',
    checkIncompleteBody: '少なくとも1つのカレンダーを一時的に読み込めなかったため、この時間が完全に空いているとは確認できません。必要であれば、このまま続行できます。',
    conflictCheckIncomplete: '一部のカレンダーを読み込めなかったため、ほかにも重複がある可能性があります。',
    conflictTitle: 'カレンダーの重複',
    reservationUnavailable: '別の予約が確定したため、この時間は利用できなくなりました。',
    reservationChanged: 'この予約は別の画面または端末で変更されました。最新の内容を読み込みました。',
    reservationPast: '開始時刻を過ぎた予約は承諾できません。',
    conflictBody: 'この時間はカレンダー内の別の予定と重なっています。それでも続行できます。',
    tentativeConflictTitle: '仮のカレンダー予定',
    tentativeConflictBody: 'この時間には、まだ確定していないカレンダー予定があります。続行する前に詳細を確認してください。',
    conflictMore: '• その他の予定：{count}件',
    continueAnyway: 'このまま続行',
    onlineCalendars: 'オンラインカレンダー',
    googleCalendar: 'Google カレンダー',
    providerConnected: '接続済み',
    providerNotConnected: '未接続',
    providerUnavailable: '公式連携を準備中です',
    googlePrivacyInfo: '選択したカレンダーだけが同期されます。タイトルと場所は最小限のサーバーキャッシュで暗号化され、説明、参加者、会議リンクは保存されません。nosubject が Google カレンダーの予定を作成、変更、削除することはできません。',
    googleConnectionFailed: 'Google カレンダーとの接続を開始できませんでした。',
    microsoftCalendar: 'Microsoft カレンダー',
    microsoftInfo: 'nosubject は空き状況のみを読み取ります（Calendars.Read）。予定の作成・変更・削除はできません。アクセスの解除は Microsoft アカウントの設定で行います。nosubject 側では取り消せません。',
    microsoftConnectionFailed: 'Microsoft カレンダーとの接続を開始できませんでした。',
    googleDisconnectTitle: 'Google カレンダーとの接続を解除しますか？',
    googleDisconnectBody: 'nosubject は Google カレンダーのデータへのアクセスを停止し、nosubject に許可した Google の権限を取り消します。Google カレンダーの予定は削除されません。',
    googleDisconnectFailed: 'Google カレンダーとの接続を解除できませんでした。',
    googleNoCalendars: '読み取り可能な Google カレンダーが見つかりませんでした。',
    googleSelectionSaveFailed: 'Google カレンダーの選択を保存できませんでした。',
  },
  instagram: {
    title: 'Instagram連携',
    connectInfo: '明示的な同意のもとでプロアカウントを連携',
    connectedAccounts: '連携済みアカウント',
    professionalAccount: 'プロアカウント',
    connect: '連携する',
    reconnect: '再連携',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'まだ連携されていません',
    unavailable: '公式連携を準備中です',
    privacyInfo: '最初の段階では、プロアカウントの識別情報を読むためのinstagram_business_basicのみを求めます。メッセージ、コメント、公開の権限は求めず、別途インポートを選ぶまで写真をnosubjectへコピーしません。',
    business: 'ビジネス',
    creator: 'クリエイター',
    connectionFailed: 'Instagram連携を開始できませんでした。',
  },
  inbox: {
    markUnread: '未読にする',
    markRead: '既読にする',
    archiveTitle: 'アーカイブ',
    archive: 'アーカイブ',
    failed: '会話を読み込めませんでした',
    searchEmpty: '結果がありません',
    archivedEmpty: 'アーカイブされた会話はありません',
    empty: 'まだ会話がありません',
    you: '自分:',
    archived: 'アーカイブしました',
    unarchived: 'アーカイブを解除しました',
    undo: '元に戻す',
    mute: 'ミュート',
    muteTitle: '{name}をミュート',
    mute1h: '1時間',
    mute8h: '8時間',
    mute1w: '1週間',
    muteForever: 'オフにするまで',
    unmute: 'ミュート解除',
    archiveAction: 'アーカイブ',
    unarchiveAction: 'アーカイブ解除',
    swipeRemove: 'アーカイブ解除',
    swipeArchive: 'アーカイブ',
    blockAction: 'ブロック',
    blockTitle: '{name}をブロックしますか？',
    blockMessage: 'この人は今後、メッセージを送信できず、「見つける」タブでもあなたを見つけられなくなります。',
    blockConfirm: 'ブロック',
  },
  message: {
    translationLanguage: "翻訳言語",
    chooseTranslationLanguage: "翻訳言語を選択",
    languageSuggestion: "端末の言語からの候補",
    translationLanguageInfo: "この非公開の設定はすべての会話の翻訳に使われます。プロフィールには追加されません。",
    photoCaption: "写真に説明を追加…",
    removePhoto: "写真を削除",
    star: "スターを付ける",
    unstar: "スターを外す",
    starred: "スター付きメッセージ",
    noStars: "この会話にスター付きメッセージはありません。",
    starFailed: "スターを更新できませんでした。もう一度お試しください。",
    starredAttachment: "添付ファイル付きメッセージ",
    edit: "メッセージを編集",
    edited: "編集済み",
    editInfo: "既読通知がオフでも、読まれるまでは編集できます。「編集」が消えることで既読と分かる場合があります。未読でも、元の文が通知のプレビューで見られた可能性があります。編集しても、発言を完全に取り消せる保証はありません。",
    editFailed: "編集を確認できませんでした。すでに読まれたか変更された可能性があります。再試行する前に会話を確認してください。",
    copy: "コピー",
    copyFailed: "メッセージをコピーできませんでした。もう一度お試しください。",
    inputPlaceholder: 'メッセージを入力…',
    typing: '入力中',
    translate: '翻訳',
    withdrawn: 'メッセージを取り消しました',
    linkOpenTitle: 'リンクを開く',
    linkOpenBody: '{host} に移動します。このリンクはメッセージを送った相手が貼ったものです。相手を知らない場合は気をつけてください。',
    linkOpenConfirm: '開く',
    linkOpenFailed: 'リンクを開けませんでした。',
    seenAt: '既読 {time}',

    priceChangedTitle: '料金が変わりました',
    priceChangedBody: 'このメッセージは {old} ではなく {new} になりました。送信しますか？',
    priceChangedSend: '送信',
    priceNoticeTitle: 'この人と話すときの料金',
    priceNoticeMessage: 'メッセージ1件 {amount}',
    priceNoticeCall: '通話 {amount}',
    priceNoticePersonal: 'この料金はあなた向けに個別に設定されています。',
    priceDecreasedTitle: "メッセージ料金が下がりました",
    priceDecreasedBody: "メッセージ料金が{old}から{new}になりました。値下げに対する承認は不要です。",
    priceChange: {
      free: '無料',
    },
    expired: '期限切れ、返金済み',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'ウェブから',
    linkViewLabel: 'リンクの表示',
    linkViewPlain: 'そのままのアドレス',
    linkViewCompact: 'コンパクト',
    linkViewCard: '大きなカード',
    linkPreviewLoading: 'プレビューを準備中…',
    linkPreviewFailed: 'このリンクのプレビューを取得できませんでした。通常のアドレスとして送信されます。',
    linkPreviewA11y: 'リンク: {title}、{host}',
    customPrice: '個別料金',
    priceUsesGeneral: '自分の通常料金が適用されます',
    priceRemove: '連絡先から外す',
    priceRemoveTitle: '{name} を連絡先から外しますか？',
    priceRemoveBody: '個別料金がなくなり、{name} には通常料金が適用されます。連絡先だけがメッセージを送れる設定なら、新しい会話を始められなくなります。ブロックではありません。',
    priceRemoveConfirm: '外す',
    priceRemoved: '{name} は通常料金に戻りました。',
    pricePrompt: '{name}さん向けの料金（0 = 無料）：',
    saved: '保存しました',
    priceFreeSet: '{name}さんが無料でメッセージを送れるようになりました。',
    priceSet: '{name}さん向けのメッセージ料金を{price}に設定しました。',
    saveError: '保存できませんでした。',
    photoError: '写真を送信できませんでした。',
    noConnection: '接続がありません',
    checkInternet: 'インターネット接続を確認してください。',
    sendError: 'メッセージを送信できませんでした。',
    addAttachment: '添付を追加',
    sendMessageAction: 'メッセージを送信',
    lowBalanceTitle: '残高不足',
    lowBalanceBody: 'この人のメッセージ料金より残高が少ないです。入金してもう一度お試しください。',
    reply: '返信',
    reactionA11y: '{emoji} のリアクション、合計 {count} 件',
    reactionA11yMine: '{emoji} のリアクション、合計 {count} 件、自分のものを含む',
    reactionAdd: '{emoji} でリアクションする',
    moreReactions: 'その他の絵文字',
    reactionRemove: '自分の {emoji} リアクションを削除',
    you: '自分',
    photo: '📷 写真',
    takePhoto: '写真を撮る',
    choosePhoto: 'ライブラリから選ぶ',
    chooseVideo: '動画を選ぶ',
    recordVoice: '音声メッセージ',
    micPermissionTitle: 'マイクへのアクセスが必要です',
    micPermissionBody: '音声メッセージの録音にはマイクへのアクセスが必要です。',
    voiceError: '音声メッセージを送信できませんでした',
    voiceRecording: '録音中',
    videoTooLarge: '動画が大きすぎます（最大1GB）',
    videoTooLong: '動画が長すぎます（最大10分）',
    videoError: '動画を送信できませんでした',
    videoNeedsUpdate: 'この動画を見るにはアプリを更新してください',
    voiceNeedsUpdate: 'このボイスメッセージを再生するにはアプリを更新してください',
    voiceOrderTitle: 'ボイスメッセージを依頼しました',
    encrypted: '暗号化されたメッセージ',
    identityChanged: 'この人のセキュリティキーが変わりました。多くは新しい端末か、アプリの再インストールです。',
    identityChangedVerify: 'このチャットは確認済みでした。安全番号をもう一度照合してください。',
    unencrypted: 'このチャットは暗号化されていません',
    unencryptedPeerInfo: '相手のアプリはまだエンドツーエンド暗号化に対応していません。そのため、ここで書いた内容は暗号化されずに送られ、nosubject のサーバーで読める状態になります。相手がアプリを更新すると、新しいメッセージは自動で暗号化されます。',
    unencryptedOfficialInfo: 'これは nosubject の公式アカウントです。ここで書いた内容は暗号化されずに送られ、nosubject のチームが読むことができます。',
    unencryptedSelfInfo: 'この端末では暗号化を有効にできませんでした（例: ブラウザのプライベートウィンドウではキーを保存できません）。ここから送る内容は暗号化されず、nosubject のサーバーで読める状態になります。',
    notificationOfferEnable: '通知をオンにする',
    notificationOfferEnabled: '通知はオンです',
    voiceOrderPending: '受け取り待ち',
    voiceOrderDelivered: '受け取りました',
    voiceOrderDeclined: '断られ、返金されました',
    voiceOrderExpired: '期限切れ、返金されました',
    voiceOrderAction: 'ボイスメッセージを注文',
    voiceOrderPick: '録音の長さは？',
    voiceOrderInsufficient: 'この注文には残高が足りません。',
    voiceOrderError: '注文できませんでした。',
    voiceOrderRecord: '録音して送る',
    voiceOrderDecline: '断る',
    voiceOrderDeclineTitle: '注文を断る',
    voiceOrderDeclineBody: '預かった金額はすべて注文した人に戻ります。',
    voiceOrderDeclineError: '注文を断れませんでした。',
    voiceOrderDeliverError: '録音を届けられませんでした。',
    voiceOrderRecording: '注文された録音',
    voiceOrderRemaining: '残り {length}',
    voiceOrderShortNote: '短く送れば、録音した分だけが支払われます。',
    voiceOrderRefunded: '{amount} 返金されました',
    sendLocation: '位置情報を送信',
    locationTitle: '位置情報',
    locationError: '位置情報を送信できませんでした',
    shareLiveLocation: '現在地をリアルタイムで共有',
    liveLocationHour: '1時間',
    liveLocationEightHours: '8時間',
    liveLocationOpenEnded: '停止するまで',
    liveLocationSharing: '現在地をリアルタイムで共有しています',
    liveLocationStop: '停止',
    liveLocationError: 'リアルタイムの現在地を開始できませんでした',
    liveLocationCardTitle: 'リアルタイムの現在地',
    liveLocationCardActive: '共有中',
    liveLocationCardEnded: '共有を終了しました',
    liveLocationOpen: '現在地を見る',
    liveLocationNoPoint: 'まだ位置情報がありません',
    liveLocationOpenInMaps: 'マップで開く',
    liveLocationUpdatedAgo: '{ago}に更新',
    videoShort: '🎬 動画',
    voiceShort: '🎙 ボイスメッセージ',
    liveLocationWatchedAgo: '{ago}前に見られました',
    liveLocationNotWatched: 'まだ見られていません',
    liveLocationSharerSeesYou: 'あなたが見た時間は相手に見えます',
    cameraPermissionTitle: 'カメラへのアクセスが必要です',
    cameraPermissionBody: '写真を撮るにはカメラへのアクセスを許可してください。',
    cameraError: 'カメラを開けませんでした。',
    photoLocationTitle: '写真の位置情報',
    photoLocationPromptFile: '写真ファイルから「{place}」を読み取りました。写真と一緒に表示しますか？',
    photoLocationPromptCapture: '端末の位置情報から「{place}」が見つかりました。写真と一緒に表示しますか？',
    photoLocationHide: '場所なしで送信',
    photoLocationShare: '場所付きで送信',
    photoLocationFromFile: 'ファイルから取得',
    photoLocationFromCapture: '端末の位置情報',
    photoLocationHideAfter: '場所を非表示',
    photoLocationShowAfter: '場所を表示',
    photoLocationUpdateError: '写真の位置情報を更新できませんでした。',
  },
  versionNotice: {
    title: '新しいバージョンがあります',
    body: 'セキュリティの改善と新機能のために、アプリを更新してください。',
    update: '更新',
  },
  notifications: {
    title: '通知',
    cardBody: '新しいメッセージや返信を見逃さないよう、端末の通知をオンにしてください。',
    notNow: '今はしない',
    enable: '通知をオンにする',
    device: '端末の通知',
    stateOn: 'オン · システム設定で管理',
    stateOff: 'オフ · システム設定でオンにする',
    stateAsk: '通知の許可はまだ求められていません',
    preferences: '通知設定',
    preferencesInfo: 'カテゴリー、プレビュー、端末の許可を管理',
    stateUnsupported: 'この端末ではサポートされていません',
    master: 'すべての通知',
    masterInfo: 'オフにするとすべてのプッシュ通知を停止します。カテゴリーの設定は保持されます',
    categories: 'カテゴリー',
    categoryEnabled: 'このカテゴリーの通知',
    categoryEnabledInfo: 'オフにするとこのカテゴリーのプッシュ通知を停止します。カテゴリー内の設定は保持されます',
    events: 'イベント',
    messages: 'メッセージ',
    messagesInfo: '新しいメッセージと返信',
    meetups: '対面予定',
    meetupsInfo: '提案、変更、結果',
    meetupRequests: '新しい対面予定の提案',
    meetupRequestsInfo: '対面予定が新しく提案されたとき',
    meetupUpdates: '返答とキャンセル',
    meetupUpdatesInfo: '対面予定が承諾、辞退、キャンセルされたとき',
    meetupReminders: '対面予定のリマインダー',
    meetupRemindersInfo: '承諾済みの対面予定が近づいたとき',
    calls: '通話',
    callsInfo: '着信、予約通話、不在着信',
    incomingCalls: '着信',
    incomingCallsInfo: '電話がかかってきたときに音で通知',
    callRequests: '予約通話の提案',
    callRequestsInfo: '提案が作成、承諾、辞退、キャンセルされたとき',
    callReminders: '予約通話のリマインダー',
    callRemindersInfo: '承諾済みの予約通話が近づいたとき',
    missedCalls: '不在着信',
    missedCallsInfo: '通話に応答できなかったとき',
    financial: 'お金とエスクロー',
    financialInfo: '取引ステータスの変更',
    financialEarnings: '収益とエスクロー',
    financialEarningsInfo: 'エスクローが解除されたか収益が利用可能になったとき',
    financialRefunds: '返金と期限切れ',
    financialRefundsInfo: '支払いが返金されたかエスクローが期限切れになったとき',
    financialPayouts: '出金結果',
    financialPayoutsInfo: '出金リクエストが完了または失敗したとき',
    reactions: '絵文字リアクション',
    reactionsInfo: '自分のメッセージへのリアクション', official: 'Nosubjectから', officialInfo: 'バージョン、セキュリティ、アカウントに関するNosubjectからのお知らせです。ほかの通知とは別に設定できます。オフにすると通知は届きませんが、メッセージは受信箱に届きます。',
    preview: 'メッセージのプレビュー',
    previewHidden: '非表示',
    previewHiddenInfo: '送信者もメッセージも表示しない',
    previewSender: '送信者のみ',
    previewSenderInfo: '送信者を表示し、メッセージを隠す',
    previewText: '送信者とメッセージ',
    previewTextInfo: '最大80文字を表示',
    deviceInfo: 'システムの許可はこの端末にのみ適用されます',
    openSettings: '設定を開く',
    centerTitle: '通知センター',
    centerMarkAll: 'すべて既読にする', centerMarkedAll: 'すべて既読にしました',
    centerEmpty: '通知はまだありません。',
    centerFailed: '通知を読み込めませんでした。',
    centerMarkAllFailed: '通知を既読にできませんでした。',
    centerUnknownPerson: 'ユーザー',
    centerEscrowExpiredRefunded: 'エスクロー期限切れ · 支払いを返金しました',
    centerEscrowReleasedEarning: '返信完了 · 収益を追加しました',
    centerMeetupRequest: '{name}さんから対面予定の提案が届きました',
    centerCallRequest: '{name}さんから通話予約の提案が届きました',
    centerCallReminder: '{name}さんとの予約通話がまもなくです',
    centerCallStarting: '{name}さんとの予約通話が始まります',
    centerMeetupStarting: '{name}さんとの対面予定が始まります',
    centerMeetupReminder: '{name}さんとの対面予定が近づいています',
    centerMeetupUpdate: '{name} · 対面予定：{status}',
    centerCallUpdate: '{name} · 通話予約：{status}',
    centerMeetupRescheduleRequest: '{name}さんが対面予定の新しい日時を提案しました',
    centerCallRescheduleRequest: '{name}さんが新しい通話時間を提案しました',
    centerMeetupRescheduleUpdate: '{name} · 対面予定の新しい日時：{status}',
    centerCallRescheduleUpdate: '{name} · 新しい通話時間：{status}',
    centerBell: '通知センター',
    centerBellUnread: '通知センター、未読{count}件',
  },
  profile: {
    webVisibility: '誰がウェブページを見られるか',
    webVisibilityLink: 'リンクを知る人',
    webVisibilityInfo: 'アカウントを持たない人に見えるプロフィール：nosubject.co/ユーザー名 のページです。全員：ページが検索エンジンにも表示されることがあります。リンクを知る人：アドレスを知っている人が開けます。検索エンジンには載りません。どちらの場合も、アカウントを持たない人が最終オンラインを含むプロフィール情報を取得できます。誰にも許可しない：アカウントを持たない人は誰もプロフィールを見られず、ページは「このプロフィールは表示できません」と表示します。アプリ内のプロフィールは変わりません。検索結果から消えるまで数日かかることがあります。',
    linkViewInfo: '入力したリンクの送り方を選びます。コンパクトと大きなカードでは、電話がページを一度開き、プレビューをメッセージと一緒に送ります。そのサイトにはあなたの電話の IP アドレスが見えます。暗号化されたチャットではプレビューは暗号の中にあり、暗号化されていないチャットでは nosubject がリンクとプレビューを見ることができます。そのままのアドレスではページを開きません。ウェブから送るリンクは常にそのままのアドレスで送られます。',
    linkViewAsk: '入力中に選択肢を表示',
    linkViewAskInfo: 'オンにすると、リンクを入力したときに他の2つの表示が出て、そのメッセージ用に選べます。オフにすると、リンクは常にここで選んだ表示で送られます。',
    whoCanCallInfo: '電話をかけられる人を選びます。すべての通話に適用されます。自分の連絡先とは、個別料金を設定した相手のことです。例外で一人ずつ許可またはブロックできます。',
    whoCanMessageInfo: '新しい会話を始められる人を選びます。すでに始まっている会話は変わりません。自分の連絡先とは、個別料金を設定した相手のことです。例外で一人ずつ許可またはブロックできます。',
    readReceiptsInfo: "既読通知は双方が有効にした場合のみ表示されます。オフでも「編集」が消えることで既読と分かる場合があります。",
    showTypingInfo: 'オンにすると、メッセージを書いている相手に、あなたが入力中であることが表示されます。オフにすると誰にも表示されませんが、他の人の入力中は引き続き確認できます。',
    officialAccount: '公式アカウント',
    information: 'プロフィール情報',
    logout: 'ログアウト',
    account: 'アカウント',
    accountData: 'アカウントとデータ',
    name: '名前',
    surname: '苗字',
    username: 'ユーザー名',
    usernamePlaceholder: 'ユーザー名',
    usernameChecking: '確認中…',
    usernameAvailable: '使用可能です',
    usernameTaken: 'このユーザー名は既に使用されています',
    usernameInvalid: '3〜20文字。先頭はA–Zまたはa–z。使用できるのはA–Z、a–z、0–9、_のみです。',
    usernameAdd: 'ユーザー名を追加',
    profession: '職業',
    professionNone: '職業が追加されていません',
    professionAdd: '職業を追加',
    employer: '勤務先',
    employerPlaceholder: '企業のユーザー名',
    employerInfo: '既存のnosubjectユーザー名を入力してください。この表記は勤務先の確認済みを意味しません。',
    employerNotFound: 'そのユーザー名の有効なアカウントが見つかりません。',
    employerSelf: '自分のアカウントを勤務先として登録することはできません。',
    bio: '自己紹介を書いてください…',
    prices: '料金',
    settings: '設定',
    priceMessage: 'メッセージ',
    priceVoice: 'ボイスメッセージ（1分あたり）',
    priceVoiceShort: 'ボイスメッセージ',
    priceCall: '今すぐ通話（1分あたり）',
    priceCallShort: '今すぐ通話',
    priceScheduledCall: '通話を予約（1分あたり）',
    priceScheduledCallShort: '通話を予約',
    priceVideoCall: 'ビデオ通話',
    priceVideoCallShort: 'ビデオ',
    priceTime: '対面予定（1分あたり）',
    priceTimeShort: '対面予定',
    currency: '通貨',
    saving: '保存中…',
    wallet: 'ウォレット',
    chatBackup: 'チャットのバックアップ',
    privacy: 'プライバシー',
    readReceipts: '既読通知',
    showTyping: '入力中の表示',
    keepArchived: 'アーカイブを維持',
    keepArchivedInfo: 'オフの場合、新しいメッセージが届くと会話がアーカイブから戻ります',
    whoCanMessage: '誰がメッセージを送れるか',
    whoCanCall: '誰が通話をかけられるか',
    messagesFromContact: 'この人からのメッセージ',
    callsFromContact: 'この人からの通話',
    callExceptions: '例外',
    callExceptionsEmpty: '通話の例外はまだありません',
    messageExceptionsEmpty: 'メッセージの例外はまだありません',
    exceptionsLoadFailed: '例外を読み込めませんでした',
    openProfileHint: 'この人のプロフィールを開きます',
    callExceptionBlocked: 'ブロック中',
    callsFromContactDefault: '既定',
    callsFromContactAllow: '常に許可',
    callsFromContactBlock: '許可しない',
    everyone: '全員',
    contacts: '自分の連絡先',
    nobody: '誰にも許可しない',
    blockedUsers: 'ブロックしたユーザー',
    blockedEmpty: 'まだ誰もブロックしていません',
    unblock: 'ブロック解除',
    appearance: '外観',
    light: 'ライト',
    dark: 'ダーク',
    system: 'システム',
    displayLanguage: '表示言語',
    education: '大学',
    educationAdd: '大学を追加',
    educationNone: '大学が追加されていません',
    educationLevel: 'レベル',
    searchLanguage: '言語を検索…',
    photoChange: '変更',
    saveFailed: '保存できませんでした。',
    photoFailed: '写真をアップロードできませんでした。',
    photoChanged: "別の操作で写真が変更されたか、再試行の期限が切れました。写真をもう一度選択してください。",
    deleteAccount: 'アカウントを削除',
    deleteTitle: 'アカウントを削除',
    deleteMessage: 'アカウントは30日後に完全に削除されます。この期間中に再ログインすればキャンセルできます。',
    deleteMoneyWarning: 'ウォレットとエスクローに{amount}あります。削除前に引き出すことをおすすめします。',
    deleteConfirm: '削除',
    deleteFailed: 'アカウントを削除できませんでした。',
    deletionScheduled: 'アカウントは{date}に削除されます。',
    deletionCancel: 'アカウント削除を取り消す',
    exportData: 'データをダウンロード',
    exportFailed: 'データを取得できませんでした。',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: '通話',
    discover: '見つける',
    inbox: 'メッセージ',
    calendar: 'カレンダー',
    profile: 'プロフィール',
    unreadMessages: '未読 {count} 件',
    pendingRequests: '保留中 {count} 件',
  },
};
